"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaddingStyle = exports.createPaddingBreakpointsCSS = exports.createPaddingCSS = void 0;
const helpers_1 = require("../helpers");
const breakpoint_1 = require("../helpers/breakpoint");
const types_1 = require("../types");
/**
 * Create padding string for css
 * @param padding LenghtCss {lengh: number, unit: UnitCss}
 * @param key string padding key for directional type
 */
const createPaddingCSS = (padding, key) => {
    if (key) {
        return `padding-${key}: ${padding.length}${padding.unit};`;
    }
    else {
        return `padding: ${padding.length}${padding.unit};`;
    }
};
exports.createPaddingCSS = createPaddingCSS;
/**
 * Create padding string using breakpoints and Media Query
 * @param padding LenghtCss {lengh: number, unit: UnitCss}
 * @param key string padding key for directional type
 */
const createPaddingBreakpointsCSS = (padding, key) => Object.keys(padding)
    .sort((a, b) => (0, helpers_1.compareBreakpoints)(a, b))
    .reduce((result, breakpoint) => {
    const paddingStyle = padding[breakpoint];
    const cssStyle = (0, exports.createPaddingCSS)(paddingStyle, key);
    return (0, breakpoint_1.mediaQueryTemplate)(breakpoint, cssStyle, result);
}, '');
exports.createPaddingBreakpointsCSS = createPaddingBreakpointsCSS;
/**
 * Create padding style per breakpoint or directional configuration
 * @param padding Padding configuration
 * @returns css string with main style and breakpoint style
 */
function createPaddingStyle(padding, theme) {
    if (!padding) {
        return `padding: 0 ${theme.size.static450}px;`;
    }
    if ((0, breakpoint_1.isDirectionalConfig)(padding)) {
        let result = '';
        types_1.directions
            .map(key => {
            const paddingConfig = padding[key];
            if ((0, breakpoint_1.isBreakpointConfig)(paddingConfig)) {
                result += (0, exports.createPaddingBreakpointsCSS)(paddingConfig, key);
            }
            else {
                result += (0, exports.createPaddingCSS)(paddingConfig, key);
            }
        })
            .join('');
        return result;
    }
    if ((0, breakpoint_1.isBreakpointConfig)(padding)) {
        return (0, exports.createPaddingBreakpointsCSS)(padding, undefined);
    }
    return (0, exports.createPaddingCSS)(padding, undefined);
}
exports.createPaddingStyle = createPaddingStyle;
